const service = {
    getQRCode(url) {
        if (url.includes('?')) {
            let query = url.split('?')[1];
            return query.split('=')[1];
        } else {
            return url;
        }
    }
}

export default service;


// WEBPACK FOOTER //
// ./src/services/qrcodeService.js